import { useTranslation } from 'next-i18next'
import { Checkbox } from '@machobear/design-system'

import { CheckboxSection } from './elements'

const FurnishingSelector = ({ onChange, values }) => {
  const { t } = useTranslation()

  const FURNISHING = [
    {
      id: 'furnished',
      label: t('common.furnished', 'Furnished')
    },
    {
      id: 'unfurnished',
      label: t('common.unfurnished', 'Unfurnished')
    }
  ]

  return (
    <CheckboxSection>
      {FURNISHING.map(feature => (
        <Checkbox
          key={feature.id}
          type="checkbox"
          onChange={onChange}
          checked={values.includes(feature.id)}
          id={feature.id}
          label={feature.label}
        />
      ))}
    </CheckboxSection>
  )
}

export default FurnishingSelector
